const hostname = window.location.hostname;
let config = {
  URL: 'http://localhost:3100/',
  API_URL: 'http://localhost:3100/data-language/',
  IMAGE_URL: 'http://localhost:3100/gambar/',
  ELOG_API: 'http://18.139.198.78/elogapiv2/',
  nodeEnv: 'local',
  IMAGE: 'https://s3.ap-southeast-1.amazonaws.com/cache.fli.id/dev/cms/gambar/',
  siteKey: '6LcaJIsrAAAAACVHfryQq0BqtJ4kIbn_glywOzkO',
  token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtc3RfZW1wbG95ZWVfaWQiOi02OSwibXN0X2VtcGxveWVlX25hbWUiOiJERVdBIiwibXN0X2VtcGxveWVlX25payI6IjAwMDAwMDAwIiwibXN0X2VtcGxveWVlX2VtYWlsIjoiZGV2ZWxvcGVyQG1haWwuY29tIiwibXN0X2NvcnBvcmF0ZV9pZCI6MiwibXN0X2NvcnBvcmF0ZV9uYW1lIjoiUFQgRkFTVEFOQSBMT0dJU1RJSyBJTkRPTkVTSUEiLCJtc3Rfc2l0ZV9pZCI6MSwibXN0X3NpdGVfbmFtZSI6IkRDIEtBUkFXQU5HIiwibXN0X3Bvc2l0aW9uX2lkIjoxLCJtc3RfcG9zaXRpb25fbGV2ZWwiOjQsIm1zdF9wb3NpdGlvbl9uYW1lIjoiSGVhZCBvZiBPcGVyYXRpb24gJiBXYXJlaG91c2UiLCJtc3RfZGl2aXNpb25faWQiOjEsIm1zdF9kaXZpc2lvbl9uYW1lIjoiT3BlcmF0aW9uICYgV2FyZWhvdXNlIiwibXN0X2RpdmlzaW9uX2FsaWFzIjoiTyZXIiwiZ3JvdXBfaWQiOjI2LCJpYXQiOjE3NTEyNDk4OTYsImV4cCI6MTc1MTg1NDY5Nn0.pu_qprs2vjGAd-BhBLIAomYO0OAyVeyzlg8RPFvqWFg"
};

if (hostname === 'dev.fwhi.co.id') {
  config = {
    URL: 'https://aces-api.loneless.xyz/',
    API_URL: 'https://aces-api.loneless.xyz/data-language/',
    IMAGE_URL: 'https://aces-api.loneless.xyz/gambar/',
    ELOG_API: 'http://18.139.198.78/elogapiv2/',
    siteKey: '6LeMBZwrAAAAAEZsTW3ouGi816YBQC7KtjMBgItX',
    IMAGE: 'https://s3.ap-southeast-1.amazonaws.com/cache.fli.id/dev/cms/gambar/',
    nodeEnv: 'development'
  };
} else if (hostname === 'www.fwhi.co.id') {
  config = {
    URL: 'https://aces-api.fli.co.id/',
    API_URL: 'https://aces-api.fli.co.id/data-language/',
    IMAGE_URL: 'https://aces-api.fli.co.id/gambar/',
    ELOG_API: 'http://18.139.198.78/elogapiv2/',
    siteKey: '6Le8_psrAAAAAFJ3st8rozREVr7xv_M3iwJm4mAQ',
    IMAGE: 'https://s3.ap-southeast-1.amazonaws.com/cache.fli.id/dev/cms/gambar/',
    nodeEnv: 'production'
  };
}

export default config;
